import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {BlacklistDocumentModel} from '../../../shared/dto/blacklist-document.model';
import {ActivatedRoute} from '@angular/router';
import {NgWizardService} from 'ng-wizard';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ApplicantRequestService} from '../../../service/applicant-request.service';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {DocumentDetailsService} from '../../../service/document-details.service';
import {DocumentTypeService} from '../../../service/document-type.service';
import {ReversedSuspendService} from '../../../shared/service/reversed-suspend.service';
import {FormControl, FormGroup} from '@angular/forms';
import swal from "sweetalert2";
import {DocumentScannerComponent} from '../../../dashboard/online-application-detail/document-scanner/document-scanner.component';

@Component({
  selector: 'app-reversed-suspend-document-details',
  templateUrl: './reversed-suspend-document-details.component.html',
  styleUrls: ['./reversed-suspend-document-details.component.scss']
})
export class ReversedSuspendDocumentDetailsComponent implements OnInit {
  @Output() response = new EventEmitter<BlacklistDocumentModel>();
  files: File[] = [];
  documentTypes: any = [];
  documentDetails: any = [];
  selectedImage: any = [];
  savedImages: any = [];
  requestId: number;
  documentDetail: BlacklistDocumentModel;

  documentUploadFrom = new FormGroup({
    document_type: new FormControl('')
  });


  constructor(private route: ActivatedRoute,
              private modalService: NgbModal,
              private ngWizardService: NgWizardService,
              public applicantRequestService: ApplicantRequestService,
              public documentTypeService: DocumentTypeService,
              private spinnerService: NgxUiLoaderService,
              private documentDetailsService: DocumentDetailsService,
              private suspendService: ReversedSuspendService) {
    this.route.paramMap.subscribe(params => {
      this.requestId = +this.decodeBase64(params.get('id'));
    });
  }

  ngOnInit() {
    this.onLoadDocumentType();
  }

  decodeBase64(code: string): string {
    return atob(code);
  }

  onScann() {
    const modalRef = this.modalService.open(DocumentScannerComponent, {
      windowClass: 'xlModal'
    });
  }


  onSubmit(element) {
    // http://localhost:8081/api/applicant/uploadFile
    this.spinnerService.start();
    const formData: FormData = new FormData();
    formData.append('file', element);

    this.applicantRequestService.uploadFiles(formData).subscribe(
      (result: any) => {
        this.spinnerService.stop();
        this.getSavedDocumentDetailsFromDocumentId(result.result);
        swal.fire(result.messageStatus , result.message, result.messageClass);
      }, (error) => {
        console.error(error);
        this.spinnerService.stop();
      }
    );
  }

  onSelect(event) {
    this.files.push(...event.addedFiles);
    this.files.forEach(element => {
      this.onSubmit(element);
    });
  }

  onRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);
  }

  onLoadDocumentType() {
    this.documentTypeService.getAllDocumentType().subscribe(
      (result: any) => {
        this.documentTypes = result;
      }
    );
  }

  getSavedDocumentDetailsFromDocumentId(id) {
    this.documentDetailsService.getAllDocumentType(id).subscribe(
      (result: any) => {
        result.forEach(element => {
          this.documentDetails.push(element);
        });
      }
    );
  }

  onSelectImage(item) {
    if (this.selectedImage.includes(item)) {
      // remove
      const index = this.selectedImage.indexOf(item);

      if (index > -1) {
        this.selectedImage.splice(index, 1);
      }

    } else {
      this.selectedImage.push(item);
    }
  }

  saveDocumentTypeAndDetails() {
    const document_type1 = this.documentUploadFrom.controls['document_type'].value;

    if (document_type1 !== '' ) {
      const documentUploadFromData = {
        pageList: this.selectedImage,
        document_type: document_type1,
        requestId: this.requestId
      };

      const copyOfDetails = [...this.documentDetails];
      this.documentDetails = [];
      this.selectedImage = [];

      this.suspendService.saveDocumentTypeAndDetails(documentUploadFromData).subscribe(
        (result: any) => {
          let myMap = new Map();

          copyOfDetails.forEach(element => {
            myMap.set(element.document.documentId, element.document.documentId);
          });

          myMap.forEach(element => {
            this.getSavedDocumentDetailsFromDocumentId(element);
          });

          // result.forEach(element => {
          //   this.savedImages.push(element);
          // });
        }
      );
      this.documentDetail = documentUploadFromData;
      this.response.emit(this.documentDetail);
    } else {
      swal.fire('error' , 'Selecte a Document Type', 'error');
    }

  }


}
